import { useCallback, useState } from "react";

export type ThemeChoice = "system" | "light" | "dark";
const KEY = "amber-theme";

function read(): ThemeChoice {
  try {
    const value = localStorage.getItem(KEY);
    return value === "light" || value === "dark" ? value : "system";
  } catch {
    return "system";
  }
}

export function useTheme(): [ThemeChoice, (next: ThemeChoice) => void] {
  const [theme, setTheme] = useState<ThemeChoice>(read);
  const choose = useCallback((next: ThemeChoice) => {
    setTheme(next);
    try {
      if (next === "system") localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, next);
    } catch {
      // storage can be unavailable in private windows; the choice then lasts for this page only
    }
    if (next === "system") delete document.documentElement.dataset["theme"];
    else document.documentElement.dataset["theme"] = next;
  }, []);
  return [theme, choose];
}
